import { render } from "./Quiz.vue?vue&type=template&id=571adf0c&scoped=true&ts=true"
import script from "./Quiz.vue?vue&type=script&lang=ts"
export * from "./Quiz.vue?vue&type=script&lang=ts"

import "./Quiz.vue?vue&type=style&index=0&id=571adf0c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571adf0c"]])

export default __exports__